import { useParams } from 'react-router-dom'
import {
  useGetInternalAccountAndBranchQuery,
  useGetPlannerAccountAndBranchesQuery,
  useGetMeQuery,
} from '@/core/api/graphql/forshawGraphqlApi.generated.ts'
import { useEffect, useState } from 'react'

interface Account {
  id: number
  name: string
  erpCatalogs?: string[]
}

interface Branch {
  id: number
  name: string
}

enum Roles {
  Planner = 'planner',
  Internal = 'internal',
}

const useGetAccountBranch = () => {
  const { accountId: accountIdParam, branchId: branchIdParam } = useParams()

  const accountId = Number(accountIdParam)
  const branchId = Number(branchIdParam)

  const { data: { me } = {} } = useGetMeQuery()

  const [account, setAccount] = useState<Account | null>(null)
  const [branch, setBranch] = useState<Branch | null>(null)

  const role = me?.role

  const { data: { planner } = {} } = useGetPlannerAccountAndBranchesQuery(
    {},
    { skip: role !== Roles.Planner },
  )
  const { data: { internal } = {} } = useGetInternalAccountAndBranchQuery(
    { accountId, branchId },
    { skip: role !== Roles.Internal },
  )

  useEffect(() => {
    if (!internal) {
      return
    }

    const { accounts } = internal
    const account = accounts?.nodes?.[0]
    const accountName = account?.name ?? ''
    const erpCatalogs = account?.erpCatalogs

    const branchName = account?.branches?.[0]?.name ?? ''

    setAccount({
      id: accountId,
      name: accountName,
      erpCatalogs,
    })

    setBranch({
      id: branchId,
      name: branchName,
    })
  }, [accountId, branchId, internal])

  useEffect(() => {
    if (!planner) {
      return
    }

    const { account: plannerAccount, branches: plannerBranches } = planner
    const accountName = plannerAccount?.name ?? ''

    const branch = plannerBranches?.find((branch) => branch?.id === branchId)

    const branchName = branch?.name ?? ''

    setAccount({
      id: accountId,
      name: accountName,
    })

    setBranch({
      id: branchId,
      name: branchName,
    })
  }, [accountId, branchId, planner])

  return {
    account,
    branch,
  }
}

export { useGetAccountBranch }
